import React from 'react'
import cn from 'classnames'

import { isEmpty, getLength } from 'util/arrays'
import { propFunc } from 'util/functions'

import withTruncatedList from '../shared/withTruncatedList'
import styles from './styles.css'

const LabelList = props => {
  const { labels } = props

  if (!labels || labels.length === 0) {
    return <EmptyState {...props} />
  }

  return <NormalState {...props} />
}

const EmptyState = ({ enterEditingState, className }) => (
  <div className={className}>
    <div className={styles.empty} onClick={propFunc(enterEditingState, null)}>
      Add tag
    </div>
  </div>
)

const NormalState = ({
  className,
  enterEditingState,
  labelClassName,
  truncatedLabels,
  visibleLabels,
}) => {
  return (
    <div className={cn(styles.labels, className)}>
      {visibleLabels.map(label => (
        <div
          className={cn(styles.label, labelClassName)}
          onClick={propFunc(enterEditingState, label)}
        >
          {label.name}
        </div>
      ))}
      {!isEmpty(truncatedLabels) && (
        <div
          className={cn(styles.label, labelClassName)}
          onClick={propFunc(enterEditingState, {})}
        >
          {`+${getLength(truncatedLabels)}`}
        </div>
      )}
    </div>
  )
}

export default withTruncatedList(LabelList)
